function Formular(ori){
    console.log('ori', ori)
    let str = []
    if(ori.subjectId == 2 && ori.stage == 50){
      //高中数学
      str = this.highMath()
    }else if(ori.subjectId == 2 && ori.stage == 20){
      //数学通用
      str = this.commonMath()
    }else if(ori.subjectId == 2 && ori.stage == 30){
      //小学数学
      str = this.primaryMath()
    }else if(ori.subjectId == 2 && ori.stage == 40){
      //初中数学
      str = this.midMath()
    }else if(ori.subjectId == 4 && ori.stage == 20){
      //通用物理
      str = this.commonPhy()
    }else if(ori.subjectId == 4 && ori.stage == 40){
      //初中物理
      str = this.midPhy()
    } else if(ori.subjectId == 4 && ori.stage == 50){
      //高中物理
      str = this.highPhy()
    } else if(ori.subjectId == 5 && ori.stage == 20){
      //通用化学
      str = this.commonChem()
    } else if(ori.subjectId == 5 && ori.stage == 40){
      //初中化学
      str = this.midChem()
    } else if (ori.subjectId == 5 && ori.stage == 50) {
      //高中化学
      str = this.highChem()
    }
    return str
  }
  Formular.prototype.highMath = function(){
    console.log('高中数学')
    return [
      'square_root', 'cube_root', 'root', 'cube', 'r_superscript', 'lefttsrightm', 'lefttmrights', 'leftrightm', 'leftrights',
      'infty', 'pi_common', 'overrightarrow', 'plus_minus', 'r_subscript', 'r_sub_sup',    
      'percent', 'compare', 'modulus_common', 'approx', 'degree', 'angle', 'perpendicular',
      'parallel_to', 'triangle', 'parallelogram', 'bigcirc', 'wideparen', 'bracket', 'braces','direc_num','shuxian','in', 'notin', 'supseteq', 'subseteq', 'supset', 'subset',
      'cap', 'cup', 'complement', 'complementu', 'emptyset',
      'alpha', 'beta', 'gamma', 'theta', 'delta', 'phi', 'epsilon', 'rho', 'omega', 'Delta', 'Omega', 'Phi', 'lg', 'ln', 'log',
      'binary_equations', 'ternary_equations', 'sin', 'cos', 'tan', 'csc', 'cot', 'sec'
    ];
  }

  Formular.prototype.commonMath = function(){
    console.log('通用数学')
    return ["round_brackets", "bracket", "less_equal", "greater_equal", "square", "cube", "fraction", "pi_common", "percent", "dotx", "approx", "degree", "angle", "perpendicular", "parallel_to", "compare", "r_superscript", "square_root", "root", "chinese_or", "chinese_and", "chinese_both", "plus_minus", "r_subscript", "r_sub_sup", "modulus_common", "direc_num", "direc_duble_num", "overrightarrow", "ne", "cong", "simeq", "triangle", "parallelogram", "bigcirc", "wideparen", "braces", "alpha", "beta", "gamma", "theta", "delta", "phi", "Delta", "Phi", "sin", "cos", "tan", "cot", "lefttsrightm", "lefttmrights", "leftrightm", "leftrights", "infty", "emptyset", "in", "notin", "supseteq", "subseteq", "supset", "subset", "cap", "cup", "complement", "complementu", "epsilon", "rho", "omega", "Omega", "lg", "ln", "log", "csc", "sec", "binary_equations", "ternary_equations"];
  }
  
  Formular.prototype.primaryMath = function(){
    console.log('小学数学')
    return [
        'bracket', 'cube', 'pi_common', 'percent', 'dotx', 'approx', 'degree', 'angle', 'perpendicular', 'parallel_to', 'compare', 'alpha', 'beta', 'theta'
    ];
  }
  
  Formular.prototype.midMath = function(){
    console.log('初中数学')
    return [
        'r_superscript', 'square_root', 'cube_root', 'root', 'cube',
        'chinese_or', 'chinese_and', 'chinese_both', 'compare', 'pi_common', 'plus_minus', 'r_subscript', 'r_sub_sup', 'percent',
        'dotx','modulus_common','direc_num','direc_duble_num','overrightarrow',
        'approx','cong','sim','degree','angle','perpendicular','parallel_to','triangle','parallelogram','bigcirc','wideparen',
        'bracket','braces',
        'alpha','beta','gamma','theta','delta','phi','Delta','Phi',
        'binary_equations','ternary_equations','sin','cos','tan','cot'
    ]
  }
  
  Formular.prototype.commonPhy = function(){
    console.log('通用物理')
    return ["xie", "cdot", "plus_minus", "fraction", "square_common", "square_root_common", "r_superscript", "r_subscript", "r_sub_sup", "percent", "compare", "direc_num", "direc_duble_num", "overrightarrow", "l_superscript", "l_subscript", "l_sub_sup", "ne", "less_equal", "greater_equal", "approx", "degree", "round_brackets", "bracket", "braces", "serial_one", "serial_two", "serial_three", "serial_four", "serial_five", "serial_six", "serial_seven", "serial_eight", "serial_nine", "centigrade", "fahrenheit", "alpha", "beta", "gamma", "theta", "pi", "rho", "omega", "Delta", "Omega", "mu", "modulus", "angle", "perpendicular", "parallelogram", "triangle", "lg", "rome_one", "rome_two", "rome_three", "rome_four", "rome_five", "rome_six", "rome_seven", "rome_eight", "rome_nine", "rome_teen", "delta", "phi", "epsilon", "Phi"]
  }

  Formular.prototype.midPhy = function(){
    console.log('初中物理')
    return [
      'r_superscript', 'r_subscript', 'rho', 'direc_num', 'xie', 'centigrade', 'percent', 'Omega', 'square_root_common', 'degree', 'compare', 'cdot',
      'serial_one','serial_two','serial_three','serial_four','serial_five','serial_six','serial_seven','serial_eight','serial_nine',
      'square_common', 'direc_duble_num', 'theta', 'pi', 'alpha', 'beta', 'gamma', 'fahrenheit', 'Delta', 'bracket', 'braces', 'approx',
      'plus_minus', 'mu', 'omega', 'l_superscript', 'l_subscript', 'r_sub_sup', 'l_sub_sup', 'overrightarrow'
    ]
  }

  Formular.prototype.highPhy = function(){
    console.log('高中物理')
    return [
      'r_superscript', 'r_subscript', 'square_root_common', 'direc_num', 'xie', 'mu', 'pi', 'Delta', 'theta', 'omega', 'cdot', 'percent',
      'compare', 'rho', 'Omega', 'Phi', 'phi', 'alpha', 'beta', 'gamma', 'epsilon', 'approx',
      'r_sub_sup', 'l_sub_sup', 'direc_duble_num', 'plus_minus', 'bracket', 'degree', 'angle', 'perpendicular', 'parallel_to', 'triangle', 'braces',
      'centigrade', 'fahrenheit', 'square_common', 'delta', 'overrightarrow',
      'serial_one', 'serial_two', 'serial_three', 'serial_four', 'serial_five', 'serial_six', 'serial_seven', 'serial_eight', 'serial_nine',
      'lg', 'l_superscript', 'l_subscript', 'rome_one', 'rome_two', 'rome_three', 'rome_four', 'rome_five', 'rome_six', 'rome_seven', 'rome_eight', 'rome_nine', 'rome_teen', 'modulus',
    ]
  }

  Formular.prototype.midChem = function(){
    console.log('初中化学')
    return [
      'cdot', 'r_superscript', 'r_subscript', 'r_sub_sup', 'uparrow', 'downarrow',
      'l_superscript', 'l_subscript', 'l_sub_sup', 'square_root_common', 'direc_num', 'pi', 'rho', 'omega', 'Delta', 'approx', 'degree', 'bracket', 'braces', 'root',
      'serial_one', 'serial_two', 'serial_three', 'serial_four', 'serial_five', 'serial_six', 'serial_seven', 'serial_eight', 'serial_nine',
      'centigrade', 'fahrenheit', 'xrightarrow_chemical', 'xlongequal_chemical', 'xrightleftharpoons_chemical', 'leftarrow', 'toarrow', 'percent', 'compare','xinghao'
    ]
  }

  Formular.prototype.highChem = function(){
    return [
        'cdot','plus_minus','square_common','square_root_common',
        'r_superscript','r_subscript','r_sub_sup','percent',
        'infty','compare','xinghao','modulus','direc_num','direc_duble_num','l_superscript','l_subscript','l_sub_sup',
        'approx','degree','bracket','braces','lg','root',
        'serial_one','serial_two','serial_three','serial_four','serial_five','serial_six','serial_seven','serial_eight','serial_nine',
        'centigrade','fahrenheit','xrightarrow_chemical','xlongequal_chemical','xrightleftharpoons_chemical',
        'leftarrow','toarrow','uparrow','downarrow',
        'rome_one','rome_two','rome_three','rome_four','rome_five','rome_six','rome_seven','rome_eight','rome_nine','rome_teen',
        'alpha','beta','gamma','theta','pi','delta','phi','epsilon','rho','omega','Delta','Omega','Phi','binary_equations','ternary_equations'
    ]
  }

  Formular.prototype.commonChem = function(){
    return ["cdot", "fraction", "square_common", "square_root_common", "r_superscript", "r_subscript", "r_sub_sup", "percent", "compare",'xinghao', "direc_num", "l_superscript", "l_subscript", "l_sub_sup", "ne", "less_equal", "greater_equal", "approx", "degree", "round_brackets", "bracket", "braces", "serial_one", "serial_two", "serial_three", "serial_four", "serial_five", "serial_six", "serial_seven", "serial_eight", "serial_nine", "centigrade", "fahrenheit", "xrightarrow_chemical", "xlongequal_chemical", "xrightleftharpoons_chemical", "leftarrow", "toarrow", "uparrow", "downarrow", "pi", "rho", "omega", "Delta", "plus_minus", "infty", "modulus", "direc_duble_num", "lg", "root", "rome_one", "rome_two", "rome_three", "rome_four", "rome_five", "rome_six", "rome_seven", "rome_eight", "rome_nine", "rome_teen", "alpha", "beta", "gamma", "theta", "delta", "phi", "epsilon", "Omega", "Phi", "binary_equations", "ternary_equations"]
  }
  
  export default Formular
  